import {
  FETCH_NATIONALITY,
  FETCH_NATIONALITY_STATE,
  FETCH_NATIONALITY_FAIL
} from '../actions/types';


export function FetchNationality(state = [], action){
  switch (action.type) {
    case FETCH_NATIONALITY:
      return action.payload.data.data;
    case FETCH_NATIONALITY_FAIL:
      return [];
    default:
      return state;
  }
}


export function FetchNationalityState(state = [], action){
  switch (action.type) {
    case FETCH_NATIONALITY_STATE:
      return action.payload.data.data;
    case FETCH_NATIONALITY_FAIL:
      return [];
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_nationality.js